interface PatternAnalyzerIconProps {
  size?: number;
  color?: string;
}

/**
 * Pattern Analyzer Icon Component
 * @description A server/log panel icon representing log analysis and pattern detection
 */
export const PatternAnalyzerIcon: React.FC<PatternAnalyzerIconProps> = ({ 
  size = 24, 
  color = 'currentColor' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M2.25 2.25V8.1h19.5V2.25zM4.2 4.2h1.954v1.954H4.2zm-1.95 5.85v11.7h19.5v-11.7zm2.925 2.925h13.65v1.95H5.175zm0 3.9h5.85v1.95h-5.85z"
      />
    </svg>
  );
};

export default PatternAnalyzerIcon;
